import Vue from 'vue'
import router from '@/router'
import messageBox from './src/MessageBox.vue'

let MessageBoxConstructor = Vue.extend(messageBox)
let instance = null,
  promise

MessageBoxConstructor.prototype.close = function(result) {
  let me = this
  instance = null
  if (me.$el && me.$el.parentNode) {
    me.$el.parentNode.removeChild(me.$el)
  }

  if (result === 'ignore') {
    // 忽略 promise
  } else if (result === 'yes') {
    this.resole()
  } else {
    this.reject()
  }
  me.$destroy()
}

const create = options => {
  if (!instance) {
    instance = new MessageBoxConstructor({ data: options })
    instance.$mount()
    document.body.appendChild(instance.$el)
  }
  promise = new Promise((resole, reject) => {
    instance.resole = resole
    instance.reject = reject
  })
  return promise
}

let MessageBox = {}

function getOptions(options) {
  return typeof options === 'string' ? { message: options } : options
}

MessageBox.confirm = function(options) {
  return create(
    Object.assign(getOptions(options), {
      showConfirmButton: true,
      showCancelButton: true
    })
  )
}

MessageBox.alert = function(options) {
  return create(
    Object.assign(getOptions(options), {
      showConfirmButton: true,
      showCancelButton: false
    })
  )
}

MessageBox.msgBox = function(options) {
  create(getOptions(options)).catch(() => {})
  return instance
}

Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$msgBox = MessageBox.msgBox

// 路由切换关闭消息
router.afterEach(() => {
  instance && instance.closeOnRouteChange && instance.close('ignore')
})

export default MessageBox
